module.exports = __webpack_public_path__ + "img/useBanner-id.09a92821.png";